export const SETTINGS = 'SETTINGS'
export const SETTINGS_SUCCEEDED = 'SETTINGS_SUCCEEDED'
export const SETTINGS_FAILED = 'SETTINGS_FAILED'
export const APP_FEEDBACK = 'APP_FEEDBACK'
export const CHECKIN_DONE = 'CHECKIN_DONE'
export const GO_BACK = 'GO_BACK'

export const checkinDone = () =>
  ({ type: CHECKIN_DONE, payload: {} })

export const showAppFeedback = ({ message, action, autoHideDuration }) =>
  ({ type: APP_FEEDBACK, payload: { open: true, message, action, autoHideDuration } })

export const hideAppFeedback = () =>
  ({ type: APP_FEEDBACK, payload: { open: false } })

export const settings = data =>
  ({ type: SETTINGS, payload: data })

export const settingsSucceeded = data =>
  ({ type: SETTINGS_SUCCEEDED, payload: data })

export const settingsFailed = data =>
  ({ type: SETTINGS_FAILED, payload: data })

export const goBack = pathname =>
  ({ type: GO_BACK, payload: { from: pathname } })



// WEBPACK FOOTER //
// ./src/actions/ui.jsx